import { Table } from 'element-ui'

const YTable = Table
YTable.$depends = [Table]
YTable.$name = 'y-table'
YTable._name = 'Table 表格'

export default YTable
